import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-tratamiento-datos',
  templateUrl: './tratamiento-datos.component.html',
  styleUrl: './tratamiento-datos.component.scss'
})
export class TratamientoDatosComponent {
    @Input() modalState = false;



}
